import { FC, useEffect } from 'react';
import DepartmentAddEditBaseView from './base';
import store from "./store";
import { observer } from "mobx-react";
import { Dialog, DialogActions, DialogContent, DialogTitle } from '@mui/material';
import { useTranslation } from 'react-i18next';
import CustomButton from 'components/Button';

type PopupFormProps = {
  openPanel: boolean;
  id: number;
  onBtnCancelClick: () => void;
  onSaveClick: (id: number) => void;
};

const DepartmentPopupForm: FC<PopupFormProps> = observer((props) => {
  const { t } = useTranslation();

  useEffect(() => {
    if (props.openPanel) {
      store.doLoad(props.id);
    } else {
      store.clearStore();
    }
  }, [props.openPanel]);

  return (
    <Dialog open={props.openPanel} onClose={props.onBtnCancelClick} maxWidth="sm" fullWidth>
      <DialogTitle>Отдел</DialogTitle>
      <DialogContent>
        <DepartmentAddEditBaseView isPopup={true} />
      </DialogContent>
      <DialogActions>
        <CustomButton
          variant="contained"
          id="id_departmentSaveButton"
          onClick={() => store.onSaveClick((id) => props.onSaveClick(id))}
        >
          {t("common:save")}
        </CustomButton>
        <CustomButton
          variant="contained"
          id="id_departmentCancelButton"
          onClick={() => props.onBtnCancelClick()}
        >
          {t("common:cancel")}
        </CustomButton>
      </DialogActions>
    </Dialog>
  );
});

export default DepartmentPopupForm;
